<template>
<div>
    <div class="card">
        <div class="card-body">
            <div class="d-flex align-items-center mb-4">
                <h5 class="card-title flex-grow-1 mb-0">Your job settings</h5>
                <div class="flex-shrink-0">
                    <button @click="popupModalShow = true" class="btn btn-primary" type="button">
                        Update <span class="d-none d-sm-inline">Settings</span>
                    </button>
                </div>
            </div>
            <CommonSpinner v-if="isLoading" />
            <div v-else class="">
                <div class="row g-3 mb-4">
                    <div class="col-sm-5 col-lg-3"><span class="text-muted">Highest qualification:</span></div>
                    <div class="col-sm-7 col-lg-9">
                        <div v-if="item.candidate.highest_qualification">
                            <h6 v-if="item.candidate.highest_qualification.qualification" class="mb-1">{{ item.candidate.highest_qualification.qualification.title }} <span v-if="item.candidate.highest_qualification.qualification.description">- {{ item.candidate.highest_qualification.qualification.description }}</span></h6>
                            <p class="mb-0" v-if="item.candidate.highest_qualification.institution">{{  item.candidate.highest_qualification.institution.title }}</p>
                            <p class="mb-0" v-else>{{  item.candidate.highest_qualification.institution_name }}</p>
                        </div>
                        <span v-else>Nothing selected</span>
                    </div>
                </div>
                <div class="row g-3 mb-4">
                    <div class="col-sm-5 col-lg-3"><span class="text-muted">Expected Salary Range:</span></div>
                    <div class="col-sm-7 col-lg-9">
                        <div v-if="item.candidate.salary_range"> {{ item.candidate.salary_range.title }}</div>
                        <span v-else>Nothing selected</span>
                    </div>
                </div>
                <div class="row g-3 mb-4">
                    <div class="col-sm-5 col-lg-3"><span class="text-muted">Expected Work type:</span></div>
                    <div class="col-sm-7 col-lg-9">
                        <div v-if="item.candidate.work_type"> {{ $filters.textFromSlug(item.candidate.work_type) }}</div>
                        <span v-else>Nothing selected</span>
                    </div>
                </div>
                <div class="row g-3">
                    <div class="col-sm-5 col-lg-3"><span class="text-muted">About Information:</span></div>
                    <div class="col-sm-7 col-lg-9">
                        <div v-html="preText(item.candidate.about)"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <b-modal size="lg" v-model="popupModalShow" hide-footer centered
        title="Update profile setting"
        title-class="fs-6" body-class="loading-viewport" @hide="initializeAll()">
        <profile-setting-form v-if="popupModalShow" @closeMe="initializeAll()"
          :edit-item="item.candidate" @updatedItem="updateItem($event)" />
    </b-modal>
</div>
</template>

<script>
import ProfileSettingForm from '@/components/forms/ProfileSettingForm.vue';

export default {
    components:{
        ProfileSettingForm,
    },
    props:{
        item: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            isLoading: false,
            popupModalShow: false,
        }
    },
    methods: {
        updateItem(item){
           this.$emit('fetchItem')
        },
        initializeAll(){
            this.popupModalShow = false;
        },
    },
    created(){
    },
}
</script>

<style></style>